const normalizeNumber = value => {
    if (value === null || value === '' || typeof value === 'undefined') {
        return null
    }

    const normalized = Number(value)
    return Number.isFinite(normalized) ? normalized : null
}

const normalizeId = value => (
    value === null || typeof value === 'undefined' ? null : String(value)
)

const getConcentrationRanges = list => {
    if (Array.isArray(list && list.concentrationRanges)) {
        return list.concentrationRanges
    }

    return Array.isArray(list && list.concentrationRange) ? list.concentrationRange : []
}

const resolveConcentrationRange = (list, selectedRange) => {
    const selectedId = normalizeId(
        selectedRange && typeof selectedRange === 'object' ? selectedRange.id : selectedRange,
    )

    if (selectedId === null) {
        return null
    }

    return getConcentrationRanges(list)
        .find(range => normalizeId(range && range.id) === selectedId) || null
}

const resolveCoveredWeight = (list, preferredLegislationKeys = []) => {
    const legislations = Array.isArray(list && list.legislations) ? list.legislations : []
    const normalizedKeys = preferredLegislationKeys.map(key => String(key).toLowerCase())
    const orderedLegislations = normalizedKeys.reduce((result, key) => {
        const legislation = legislations.find(item => (
            String((item && item.key) || '').toLowerCase() === key
        ))
        return legislation ? result.concat(legislation) : result
    }, [])

    return orderedLegislations.reduce((coveredWeight, legislation) => (
        coveredWeight === null ? normalizeNumber(legislation.coveredWeight) : coveredWeight
    ), null)
}

const isRangeAboveCoveredWeight = (list, selectedRange, preferredLegislationKeys = []) => {
    const range = resolveConcentrationRange(list, selectedRange)
    const rangeFrom = normalizeNumber(range && range.from)
    const coveredWeight = resolveCoveredWeight(list, preferredLegislationKeys)

    return rangeFrom !== null && coveredWeight !== null && rangeFrom > coveredWeight
}

export {
    getConcentrationRanges,
    isRangeAboveCoveredWeight,
    resolveConcentrationRange,
    resolveCoveredWeight,
}
